var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smart-image"},[(_vm.loaded)?_c('img',{attrs:{"src":_vm.srcUrl,"alt":_vm.altText || 'Image'},on:{"load":function($event){return _vm.doneLoading(1)}}}):_c('div',{staticClass:"placeholder"},[_c('b-spinner',{attrs:{"type":"grow"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b15cd6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SmartImage.vue
// module id = null
// module chunks = 